import React, { useEffect, useState } from 'react';
import styles from './ReportInnerPage.module.scss';
import { ReportTable } from '../../components/ReportTable/ReportTable';
import { ReportRequestsCard } from '../../components/ReportRequestsCard/ReportRequestsCard';
import { useLocation } from 'react-router-dom';
import { Icon } from 'antd';
import { reportTitle } from '../../constants/reportTitle';
import { reportIcons } from '../../constants/reportIcons';
import RoundedButton from '../../../../components/RoundedButton/RoundedButton';
import { Link } from 'react-router-dom';
import { getSearchParams } from '../../helpers/searchParamsFns';
import { useSelector } from 'react-redux';
import { getDashboardReportCards } from '../../helpers/getDashboardReportCards';

export const ReportInnerPage = ({ FiltersBlock }) => {
  const location = useLocation();

  const [reportCards, setReportCards] = useState([]);

  const filteredRequests = useSelector(
    (state) => state.statisticsStore.filteredRequests
  );

  

  useEffect(() => {
    if (filteredRequests.length) {
      const cards = getDashboardReportCards(filteredRequests)

      setReportCards(cards);
    }
  }, [filteredRequests]);

  const title = reportTitle[location.pathname.split('/').pop()];

  const searchParams = getSearchParams(location.search);

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          <span className={styles.anticon}>
            <Icon
              className={styles.icon}
              component={reportIcons[title]}
            />
          </span>
          <span className={styles.title}>{title}</span>
        </div>
        <div>
          <Link
            to={{
              pathname: '/NewStatistics/report',
              search: searchParams,
            }}
          >
            <RoundedButton
              className={styles.button}
              text="Закрыть"
            />
          </Link>
        </div>
      </div>
      {FiltersBlock}
      <>
        {!!reportCards.length ? (
          <>
            <div className={styles.listOfCards}>
              {reportCards.map((item) => (
                <ReportRequestsCard
                  key={item.title}
                  title={item.title}
                  count={item.count}
                />
              ))}
            </div>
            <ReportTable />
          </>
        ) : (
          <div className={styles.noData}>
            <span className={styles.noData_text}>Нет данных</span>
          </div>
        )}
      </>
    </div>
  );
};
